import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

function AdminPage() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUsers = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/admin/users');
      setUsers(response.data);
    } catch (error) {
      toast.error('Você não tem permissão para ver esta página ou ocorreu um erro.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleApprove = async (userId) => {
    const loadingToast = toast.loading('Aprovando usuário...');
    try {
      await api.patch(`/admin/users/${userId}/approve`);
      toast.success('Usuário aprovado!');
      fetchUsers();
    } catch (error) {
      toast.error('Erro ao aprovar usuário.');
    } finally {
      toast.dismiss(loadingToast);
    }
  };

  return (
    <>
      <div className="mb-8">
        <h2 className="text-3xl font-bold font-manrope text-slate-900 tracking-tight mb-2">Painel de Administração</h2>
        <p className="text-sm font-medium text-slate-500">Gerencie usuários, permissões e monitore acessos da plataforma.</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="p-6 border-b border-slate-100 bg-slate-50 flex items-center justify-between">
           <div className="flex items-center space-x-3">
             <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center border border-indigo-100">
                <span className="material-symbols-outlined">manage_accounts</span>
             </div>
             <div>
                <h3 className="text-lg font-bold font-manrope text-slate-900">Lista de Usuários</h3>
                <p className="text-xs text-slate-500">Aprove novos cadastros e visualize a base de usuários.</p>
             </div>
           </div>
        </div>

        <div>
          {isLoading ? (
             <div className="p-12 text-center flex flex-col items-center justify-center text-slate-400 gap-4">
                <span className="material-symbols-outlined animate-spin text-4xl">refresh</span>
                <p className="text-sm font-bold">Carregando usuários...</p>
             </div>
          ) : users.length === 0 ? (
             <div className="p-12 text-center flex flex-col items-center justify-center text-slate-400 gap-4">
                <span className="material-symbols-outlined text-4xl">person_off</span>
                <p className="text-sm font-bold">Nenhum usuário foi encontrado.</p>
             </div>
          ) : (
             <ul className="divide-y divide-slate-100">
               {users.map(user => (
                 <li key={user.id} className="p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors">
                   <div className="flex items-center gap-4">
                     <div className="w-12 h-12 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-400 flex-shrink-0">
                       <span className="material-symbols-outlined">person</span>
                     </div>
                     <div>
                       <h4 className="text-sm font-bold text-slate-900 flex items-center gap-2">
                         {user.name} 
                         {user.role === 'admin' && (
                           <span className="text-[10px] uppercase tracking-wider font-bold bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded border border-indigo-200">Admin</span>
                         )}
                       </h4>
                       <p className="text-xs text-slate-500 mt-1">{user.email}</p>
                     </div>
                   </div>
                   
                   <div className="flex justify-end">
                     {user.is_approved ? (
                       <span className="flex items-center gap-1.5 text-xs font-bold bg-[#f0fdf4] text-[#16a34a] px-3 py-2 rounded-lg border border-[#dcfce7]">
                          <span className="material-symbols-outlined text-[16px]">check_circle</span>
                          Aprovado
                       </span>
                     ) : (
                       <button onClick={() => handleApprove(user.id)} className="flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold px-4 py-2 rounded-lg transition-colors shadow-sm">
                         <span className="material-symbols-outlined text-[16px]">how_to_reg</span>
                         Aprovar Acesso
                       </button>
                     )}
                   </div>
                 </li>
               ))}
             </ul>
          )}
        </div>
      </div>
    </>
  );
}
export default AdminPage;